module.exports = __webpack_public_path__ + "static/media/search.160b1499.svg";